.divider {
    background-color: var(--off-white-dk);
    height: calc(100% - 16px);
    width: 1px;
}

/*
This name can be confusing, but the _divider_ is horizontal, so this is used
when the stat block is vertical
*/
.divider-horizontal {
    composes: divider;
    width: calc(100% - 16px);
    height: 1px;
}

.container {
    width: 100%;
    height: 100%;
    display: flex;
    border: 1px solid var(--off-white-dk);
    border-radius: 3px;
    align-items: center;
    background-color: var(--white);
}

.container--no-border {
    composes: container;
    border: unset;
}

.stat-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/*
This is the left-align stat item
*/
.stat-container-vertical {
    composes: stat-container;
    width: 100%;
    align-items: unset;
    box-sizing: border-box;
    padding-left: 24px;
}

.stat-container-vertical--normal {
    composes: stat-container;
    width: 100%;
    align-items: unset;
    box-sizing: border-box;
    padding-left: 12px;
}

.stat-label {
    line-height: 1;
    color: var(--grey-dk);
    font-size: var(--font-normal);
}

.stat-label--center {
    text-align: center;
}

.stat-value {
    font-size: 28px;
    color: var(--grey-dk);
    margin-top: 8px;
    line-height: 1;
}

.stat-value--normal {
    composes: stat-value;
    font-size: 20px;
    margin-top: 4px;
    line-height: 1.2;
}

.stat-value--small {
    composes: stat-value;
    font-size: 15px;
    margin-top: 0;
    line-height: unset;
}

.value-icon {
    margin-top: 8px;
}

.value-icon--normal {
    composes: value-icon;
    margin-top: 4px;
}

.value-icon--small {
    composes: value-icon;
    margin-top: 0;
}

.stat-value--bold {
    composes: stat-value;
    font-weight: 500;
}

.stat-secondary-value {
    margin-top: 8px;
    font-size: var(--font-normal);
    line-height: 1;
    color: var(--grey-lt);
}

.underline-stat-value {
    composes: stat-value;
    text-align: left;
}
.underline-stat-value:hover {
    text-decoration: underline;
}

.clickable-stat {
    text-align: center;
    cursor: pointer;
}

.clickable-stat .stat-secondary-value {
    display: block;
}

.clickable-stat:hover .stat-secondary-value {
    color: var(--grey);
    text-decoration: underline;
}

.tooltip-wrapper {
    display: flex;
    align-items: center;
}
